import { render } from "./edit_power.vue?vue&type=template&id=455dd126"
import script from "./edit_power.vue?vue&type=script&lang=js"
export * from "./edit_power.vue?vue&type=script&lang=js"

import "./edit_power.vue?vue&type=style&index=0&id=455dd126&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_pms_web\\pms_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__